import { useState, useEffect, useRef } from "react";
import Styles from "./IconButton.module.scss";
import buttonBackgroundBlue from "assets/images/chase/Small_Button_Highlight_Selected.png";

const IconButton = ({ icon, alt, onClick, rotation, type, text }) => {
    const rotationMap = {
        up: 90,
        down: -90,
        left: 0,
        right: 180,
    };

    const angle = rotationMap[rotation] ?? 0;

    return (
        <button className={Styles.Button} onClick={onClick}>
            {
                type === "icon" && (
                    <img
                        className={Styles.Icon}
                        src={icon}
                        alt={alt}
                        style={{ transform: `rotate(${angle}deg)` }}
                    />
                )
            }
            {
                type === "text" && (
                    <span className={Styles.Text}>{text}</span>
                )
            }

        </button>
    );
};

export default IconButton;